
import Vue from 'vue';

import { BlockCollection } from '@headlines/exports';

import getArticles from '@custom/core/apollo/services/getArticles';
import { GetArticles } from '@custom/core/apollo/types/getArticles';

interface Props {
  ids: number[];
  categoryId: number[];
  tagId: number[];
  limit: number;
  blockTitle: string;
  grid: string;
}
interface Data {
  articles: GetArticles['data']['articles']['items'];
}

export default Vue.extend<Data, unknown, unknown, Props>({
  components: {
    BlockType8: BlockCollection.BlockType8,
    BlockType3: BlockCollection.BlockType3,
    BlockType102: BlockCollection.BlockType102,
  },

  props: {
    ids: {
      type: Array,
    },
    categoryId: {
      type: Array,
    },
    tagId: {
      type: Array,
    },
    limit: {
      type: Number,
      default: 30,
    },
    blockTitle: {
      type: String,
      default: '',
    },
    grid: {
      type: String,
    },
  },

  data() {
    return {
      articles: [],
    };
  },
  async created() {
    if (this.ids) {
      const response = await getArticles({ ids: this.ids, limit: this.limit });

      for (const article of response.articles.items) {
        article.href = 'https://delfi.lt/a/' + article.id;
      }
      this.articles = response.articles.items;
    } else if (this.categoryId) {
      const response = await getArticles({ categoryId: this.categoryId, limit: this.limit });
      for (const article of response.articles.items) {
        article.href = 'https://delfi.lt/a/' + article.id;
      }
      this.articles = response.articles.items;
    } else if (this.tagId) {
      const response = await getArticles({ tagId: this.tagId, limit: this.limit });
      for (const article of response.articles.items) {
        article.href = 'https://delfi.lt/a/' + article.id;
      }
      this.articles = response.articles.items;
    } else {
      console.log('finger');
    }
  },
});
